var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 3.75a7.917 7.917 0 1 0 0 15.833A7.917 7.917 0 0 0 15 3.75m-3.83 4.087a5.417 5.417 0 1 1 7.66 7.66 5.417 5.417 0 0 1-7.66-7.66",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.837 27.837a5.42 5.42 0 0 1 3.83-1.587h6.666a5.417 5.417 0 0 1 5.417 5.417V35a1.25 1.25 0 1 0 2.5 0v-3.333a7.917 7.917 0 0 0-7.917-7.917h-6.666a7.917 7.917 0 0 0-7.917 7.917V35a1.25 1.25 0 1 0 2.5 0v-3.333c0-1.437.57-2.815 1.587-3.83M25.456 4.907a1.25 1.25 0 0 1 1.52-.9 7.916 7.916 0 0 1 0 15.338 1.25 1.25 0 0 1-.62-2.422 5.416 5.416 0 0 0 0-10.495 1.25 1.25 0 0 1-.9-1.521M30.313 24.04a1.25 1.25 0 1 0-.625 2.42 5.416 5.416 0 0 1 4.062 5.21V35a1.25 1.25 0 1 0 2.5 0v-3.3400000000000003a7.92 7.92 0 0 0-5.937-7.62"
  })));
};
export default SvgPeople;